import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/mac-desktop.svg'
import _imports_1 from '../../assets/images/mac-laptop.svg'
import _imports_2 from '../../assets/images/mac-mini.svg'
import _imports_3 from '../../assets/images/logo-landing.svg'


const _withScopeId = n => (_pushScopeId("data-v-03821ad9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "background" }
const _hoisted_2 = { class: "landing-view-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("Tenha acesso a um Mac "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("remoto quando você quiser.")
], -1))
const _hoisted_4 = { class: "landing-view-buttons" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-background img-background1",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-background img-background2",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-background img-background3",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-background img-background4",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_9 = { class: "how-to-works" }
const _hoisted_10 = { class: "how-to-works-content" }
const _hoisted_11 = { class: "how-to-works-cards" }
const _hoisted_12 = { class: "how-to-works-card" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FooterSchedule = _resolveComponent("FooterSchedule")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.userInfo)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "landing-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({name: 'Register'})))
              }, _toDisplayString(_ctx.$t("menu.register")), 1))
            : _createCommentVNode("", true),
          (!_ctx.userInfo)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "landing-outline",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.login()))
              }, _toDisplayString(_ctx.$t('menu.login')), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("menu.howToWorks")), 1),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.howToWorks, (howToWork) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("img", {
                src: howToWork.icon,
                alt: ""
              }, null, 8, _hoisted_13),
              _createElementVNode("h6", null, _toDisplayString(howToWork.title), 1),
              _createElementVNode("p", null, _toDisplayString(howToWork.content), 1)
            ]))
          }), 256))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_FooterSchedule)
    ])
  ], 64))
}